<template>
  <div class="content-box">
    <div>
      <h3>电子合同</h3>
      <div class="content-text">
        <span>-企业信息-</span>
        <div>
          <p>企业名称：{{detail.companyName||'----'}}</p>
          <p>营业执照：{{detail.businessLicenseNum||'----'}}</p>
          <p>法人身份证号码：{{detail.idCard||'----'}}</p>
        </div>
      </div>
      <div class="content-text">
        <span>-签约信息-</span>
        <div>
          <p>合同文件：
            <el-button
              @click="look_pdf"
              type="text"
              :disabled="!detail.url"
            >
              <span style="padding: 0;" v-if="detail.url">《{{detail.urlName}}》.pdf</span>
              <span style="padding: 0;" v-else>--</span>
            </el-button>
            

            <!-- <a :href="detail.url" v-if="detail.url">《胤之旅合作协议》.pdf</a> -->
          </p>
          <p>签约状态：{{detail.signStatusText||'----'}}</p>
          <p>签约时间：{{detail.endTime||'----'}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import buyerSignUrl from "@/lib/data-service/default/web_esIgn_esIgnSignerController_buyerSignUrl";
import { version } from "moment";

export default {
  name: "contentBox",
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    look_pdf() {
      window.open(this.detail.url, "_blank");
    }
  },
  created() {
    buyerSignUrl().then(res => {
      console.log(res);
      this.detail = res;
    });
  }
};
</script>
<style lang="less" scoped>
.content-box {
  border: 1px solid #dfdfdf;
  border-top: 0;
  h3 {
    background: #f4f9ff;
    padding: 8px 30px;
    position: relative;
    color: #4b4b4b;
    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      background: #237dc8;
    }
  }
  .content-text {
    font-size: 13px;
    margin-bottom: 10px;
    span:nth-child(1) {
      color: #999;
      font-size: 14px;
      display: block;
      padding: 10px 30px 5px 30px;
    }
    p {
      padding: 8px 40px;
    }
  }
}
</style>